import React from 'react'

export const PageHeader = ({title}) => {
    return (
        <div className="page-title dark-background">
            <div className="container d-lg-flex justify-content-between align-items-center">
                <h1 className="mb-2 mb-lg-0">{title}</h1>
            </div>
        </div>
    )
}
